import React, { Component } from 'react';
import { Link } from 'react-router-dom';
// Images
import Button from '../button';

import Lottie from 'lottie-react';
import landingLottie from './../../svg/landing.json';

class Carousel extends Component {
   render() {
      const { goToProductsSection } = this.props;

      return (
         <div className="flex justify-center">
            <div
               className="container"
               style={{
                  borderRadius: '8px',
                  position: 'relative',
                  justifyContent: 'center',
               }}
            >
               <div className="flex slider-car">
                  <div className="carousel">
                     {/*<OwlCarousel options={options}>
                  <div>
                     <img src={slide1} alt="ExpoMédica" />
                  </div>
                  <div>
                     <img src={slide2} alt="" />
                  </div>
                  <div>
                     <img src={slide3} alt="" />
                  </div>
               </OwlCarousel> */}
                  </div>
                  <div className="rd-parallax-layer">
                     <div className="bg-overlay-darker">
                        <div className="justify-center align-center">
                           <div className="container banner-container justify-between">
                              <div className="lottie-container">
                                 <Lottie
                                    animationData={landingLottie}
                                    loop={true}
                                 />
                              </div>
                              <div className="home-text column">
                                 <div className="first-text-c column">
                                    <h1 className="color-secondary quicksand">
                                       Venta de
                                       <span className="color-red">
                                          {' '}
                                          artículos médicos{' '}
                                       </span>
                                       y
                                       <span className="color-red">
                                          {' '}
                                          ortopédicos
                                       </span>
                                    </h1>
                                    <div className="white-space-32"></div>
                                    <h2 className="color-secondary quicksand">
                                       ¡Encuentrános en Cancún y Playa del
                                       Carmen!
                                    </h2>
                                 </div>
                                 <div className="white-space-32"></div>
                                 <div className="home-buttons justify-end">
                                    <Link to="/nosotros#cancun-location">
                                       <Button theme="dark">Ubícanos</Button>
                                    </Link>
                                    <Link to="/catalogo">
                                       <Button theme="soft-red">Comprar</Button>
                                    </Link>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="banner-circle" onClick={goToProductsSection}>
                  <i className="fas fa-arrow-down"></i>
               </div>
            </div>
         </div>
      );
   }
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/components/Sliders/carousel.js